export default __webpack_public_path__ + "static/media/about_background.17f9bc89.jpg";